import luxuryEscapesTheme, { luxuryEscapesBorderRadii, luxuryEscapesDefaultPalette, luxuryEscapesInversePalette } from './luxuryescapes'
import { baseThemeShadows } from './shadows'

export const agentHubCVFRDefaultPalette: App.Design.Palette<string> = {
  ...luxuryEscapesDefaultPalette,
}

export const agentHubCVFRInversePalette: App.Design.Palette<string> = {
  ...luxuryEscapesInversePalette,
}

export const agentHubCVFRShadows: App.Design.Shadows<string> = { ...baseThemeShadows }
export const agentHubCVFRBorderRadii: App.Design.BorderRadii<string> = { ...luxuryEscapesBorderRadii }

const agentHubCVFRTheme: App.Design.Theme = {
  ...luxuryEscapesTheme,
}

export default agentHubCVFRTheme
